import { useQuery } from "@tanstack/react-query";
import Api from "../../features/one-query/services/ApiServices";

// Get prompt library endpoint 

const getPromptLibraryRequest = async () => {
  const response = await Api.get("/PromptItem/GetPromptItems");
  return response.data;
}

const useGetPromptLibraryRequest = () => {
  return useQuery({
    queryKey: ["PromptLibrary"],
    queryFn: getPromptLibraryRequest,
    enabled: false,
  })
}

export {
    useGetPromptLibraryRequest
}